import { actionProps } from "@/lib/controlAnalytics";
import { ROUTES } from "@/lib/routes";
import PlaceLink from "./PlaceLink";
import { GRAD_BUTTON } from "./styles";

/** An address no place answers. */
export default function NotFound() {
    return (
        <section className="mx-auto flex w-full max-w-[560px] flex-col items-center gap-3 pb-14 pt-16 text-center">
            <h1 className="m-0 font-display text-[30px] font-extrabold leading-[1.1] tracking-[-0.03em]">
                Nothing is here
            </h1>
            <p className="m-0 text-[14px] text-fg-muted">
                The address may be old. The jobs are on the front page.
            </p>
            <PlaceLink
                {...actionProps("navigation_clicked", { source: "NotFound", target: ROUTES.HOME })}
                to={ROUTES.HOME}
                className={`${GRAD_BUTTON} mt-2 h-11 rounded-control px-5 text-[14px]`}
            >
                See the jobs
            </PlaceLink>
        </section>
    );
}
